// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // initialise i18n avant tout
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_test_51RnHKiR9DZ2nXXVNrruqOJZrznF1lQwYDqXdgpZ1Ex6ReOu8YBWTNXNfiCB7MMwHjIWFqDnfu0kFgxMvEbd7Palc00t1LFXPZP');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </Suspense>
  </React.StrictMode>
);
